export default "__VITE_ASSET__DCSOvPqN__"